import React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export interface DragAndDropUploadBannerProps {
  className?: string;
}

export default function DragAndDropUploadBanner({
  className,
}: DragAndDropUploadBannerProps) {
  return (
    <div
      className={cx(
        'w-full max-w-[1032px] flex items-center gap-x-5 p-2.5 bg-neutral-50 border-solid border-neutral-300 rounded-md',
        className
      )}
    >
      <FontAwesomeIcon size='2x' icon={faInfoCircle} />
      <h4 className='text-xl text-neutral-800 m-0'>
        You can now drag and drop to add files to my library!
      </h4>
    </div>
  );
}
